import React from 'react';
import { CustomModal } from 'components/molecules';
import { IconButton, Typography } from '@mui/material';
import {
  CloseSquareIcon, ErrorCircleIcon, SuccessCircleIcon, WarningCircleIcon,
} from 'assets/icons';

interface Props {
  open: boolean;
  onClose: () => void;
  title: string;
  subTitle: string;
  children: React.ReactNode;
  modalClass?: string;
  container?: Element | (() => Element | null) | null | undefined;
  icon?: 'success' | 'error' | 'warning' | undefined;
}

const ClosableModal = ({
  open, onClose, icon, title = '', subTitle = '', children, modalClass, container,
}: Props) => {
  const closeHandler = () => {
    onClose();
  };
  const modalCloseHandler = () => {};
  return (
    <CustomModal
      open={open}
      onClose={modalCloseHandler}
      modalClass={modalClass}
      container={container}
    >
      <>
        <div className="d-flex justify-content-between align-items-start mb-4 close-modal-header">
          <div className="d-flex flex-column">
            <div className="d-flex flex-row justify-content-start align-items-center mb-1">
              {icon && icon === 'success' && (
                <SuccessCircleIcon sx={{ width: '60px', height: '60px', mr: 2 }} />
              )}

              {icon && icon === 'error' && (
                <ErrorCircleIcon sx={{ width: '60px', height: '60px', mr: 2 }} />
              )}

              {icon && icon === 'warning' && (
                <WarningCircleIcon sx={{ width: '60px', height: '60px', mr: 2 }} />
              )}
              <Typography variant="h5" component="h5">{title}</Typography>
            </div>
            <Typography variant="body2" component="p" sx={{ color: 'text.secondary' }}>
              {subTitle}
            </Typography>
          </div>
          <IconButton onClick={closeHandler} sx={{ p: 0 }}>
            <CloseSquareIcon sx={{ color: 'primary.main' }} />
          </IconButton>
        </div>
        <div className="close-modal-body">
          {children}
        </div>
      </>
    </CustomModal>
  );
};

ClosableModal.defaultProps = {
  modalClass: '',
  container: undefined,
  icon: undefined,
};

export default ClosableModal;
